export default __webpack_public_path__ + "static/media/SWT0730.34I-19474_-14692_0.cf910865.jpg";